import { animationShape } from './type';

const TransitionAnimation = (props: animationShape) => {};

export default TransitionAnimation;
